import { useCurrentOrganizationMembers } from "@api/organizationMember.api";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { HStack } from "@design-system/HStack/HStack";

interface OrganizationMemberLabelProps {
    userId: number | string;
    fallbackLabel?: string;
}

export const OrganizationMemberLabel = ({
    userId,
    fallbackLabel,
}: OrganizationMemberLabelProps) => {
    const { data: members, isPending } = useCurrentOrganizationMembers();

    if (isPending) {
        return null;
    }

    const member = members?.find(
        ({ user }) => String(user.id) === String(userId),
    );

    if (!member) {
        return <>{fallbackLabel ?? `User #${userId}`}</>;
    }

    const displayName =
        member.user.name.trim() !== ""
            ? member.user.name
            : (member.user.email ?? fallbackLabel ?? `User #${userId}`);

    return (
        <HStack gap={8} align="center">
            <UserAvatar user={member.user} size="xs" aria-hidden />
            <span>{displayName}</span>
        </HStack>
    );
};
